import { Box } from 'reflexbox';
import styled from 'styled-components';

import { FlexGap, tokens } from '@treams/treams-ui';

const Track = styled(FlexGap)`
	flex-shrink: 0;
	box-sizing: border-box;
	width: 100%;
	padding: ${tokens.padding.container}px;
	padding-bottom: ${tokens.gap.group}px;
	background: ${tokens.surface.secondary};
`;

const Segment = styled(Box)<{ $active?: boolean }>`
	height: 6px;
	flex: 1;
	min-width: 0;
	border-radius: ${tokens.radius.full}px;
	background: ${(props) => (props.$active ? props.theme.colors.primary : tokens.border.subtle)};
`;

export default function FeedbackRequestProgress({ step }: { step: 0 | 1 | 2 }) {
	return (
		<Track gap={tokens.gap.inline}>
			{[0, 1, 2].map((index) => (
				<Segment key={index} $active={index <= step} />
			))}
		</Track>
	);
}
